import { queueTrackingEvent } from '@library/tracking-integration'

export enum TrackingActions {
  CLICK_GET_STARTED = 'click_get_started',
  CUSTOMER_REVIEWS_TRUSTPILOT_CTA = 'click_value_comprehension_trustpilot_cta',
  OUR_SUPPLIERS = 'click_value_comprehension_supplier_cta',
  OUR_SUPPLIERS_CAROUSEL = 'click_value_comprehension_supplier_carousel',
}

export enum LandingPageContentSections {
  CUSTOMER_REVIEWS = 'customerReviews',
  EFFORTLESS_HOME_COOKING = 'effortlessHomeCooking',
  VALUE_YOU_CAN_TASTE = 'valueYouCanTaste',
  ENDLESS_VARIETY = 'endlessVariety',
  OUR_SUPPLIERS = 'ourSuppliers',
  // snake_case per the squad's analytics spec for this event (differs from the camelCase above).
  WHATS_NEW = 'whats_new',
}

type CTAClickTrackingData = {
  action: TrackingActions
  properties: {
    section: LandingPageContentSections
    url: string
    [key: string]: unknown
  }
}

type CarouselSlideChangeTrackingData = {
  action: 'carousel_slide_change'
  properties: {
    prevSlideIndex: number
    currentSlideIndex: number
    [key: string]: unknown
  }
}

export function trackCTAClick(
  action: TrackingActions,
  landingPageContentSections: LandingPageContentSections,
  extra: Record<string, unknown> = {},
) {
  queueTrackingEvent<CTAClickTrackingData>({
    action,
    properties: {
      section: landingPageContentSections,
      url: window.location.href,
      ...extra,
    },
  })
}

export function trackCarouselSlideChange(
  prevSlideIndex: number,
  currentSlideIndex: number,
  snowplowTrackingProperties: Record<string, unknown> = {},
) {
  queueTrackingEvent<CarouselSlideChangeTrackingData>({
    action: 'carousel_slide_change',
    properties: {
      prevSlideIndex,
      currentSlideIndex,
      ...snowplowTrackingProperties,
    },
  })
}
